import * as React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Link } from 'react-router-dom'
import { Action, mk_widget, Widget } from 'widgets-for-react'
import { link } from '../../cms/blocks/utils.gen'
import { AppState } from '../../cms/state/types.gen'
import { PublicSiteState } from '../../public_site.main.mod'
import { PublicSiteCustomRoutes } from '../custom_pages/types.mod'
import { DataLayer } from '../utils/datalayer'

export const footer: (
  s: AppState<PublicSiteState, PublicSiteCustomRoutes>
) => Widget<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>> = props =>
  mk_widget({
    run: o => {
      const footerColumn = (title: string, items, colNumber: number) => {
        return (
          <li className="flex-item footer__column">
            {title && <strong className="title--xs footer__title">{title}</strong>}
            {items ? (
              <ul>
                {items.map((l, index) => (
                  <li key={`first_items-${index}`} className="footer__item">
                    {l.item.title && l.item.url
                      ? link(
                          {
                            kind: 'link',
                            title: l.item.title,
                            url: l.item.url,
                            is_link_external: true,
                            target: l.item.target === undefined || l.item.target === '' ? '_self' : l.item.target
                          },
                          {
                            classname: 'link-button footer__link'
                          },
                          l.item.title
                        )
                      : null}
                  </li>
                ))}
              </ul>
            ) : null}
            {colNumber === 4 && (
              <>
                <span className="sr-text">Volg ons op social media</span>
                <ul className="socials">
                  <li className="social social--linkedin">
                    <a
                      href="https://www.linkedin.com/company/bohn-stafleu-van-loghum/"
                      className="social__link"
                      title="Volg ons op LinkedIn"
                      target="_blank"
                    >
                      <span className="sr-text">Volg ons op LinkedIn</span>
                      <svg aria-hidden="true" width="16" height="16">
                        <use xlinkHref="#icon--linkedin" />
                      </svg>
                    </a>
                  </li>
                  <li className="social social--twitter">
                    <a
                      href="https://twitter.com/BSL"
                      className="social__link"
                      title="Volg ons op Twitter"
                      target="_blank"
                    >
                      <span className="sr-text">Volg ons op Twitter</span>
                      <svg aria-hidden="true" width="14" height="14">
                        <use xlinkHref="#icon--twitter" />
                      </svg>
                    </a>
                  </li>
                  <li className="social social--facebook">
                    <a
                      href="https://www.facebook.com/BohnStafleuvanLoghum"
                      className="social__link"
                      title="Volg ons op Facebook"
                      target="_blank"
                    >
                      <span className="sr-text">Volg ons op Facebook</span>
                      <svg aria-hidden="true" width="14" height="14">
                        <use xlinkHref="#icon--facebook" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </>
            )}
          </li>
        )
      }
      const jsx = (
        <BrowserRouter>
          <nav className="footer" aria-label="Footer">
            <div className="footer__row footer__row--top">
              <div className="footer__inner block">
                <ul className="flex flex--4">
                  {props.state.options.kind === 'loaded' && props.state.options.value.acf ? (
                    <>
                      {footerColumn(
                        props.state.options.value.acf.first_title,
                        props.state.options.value.acf.first_items,
                        1
                      )}
                      {footerColumn(
                        props.state.options.value.acf.second_title,
                        props.state.options.value.acf.second_items,
                        2
                      )}
                      {footerColumn(
                        props.state.options.value.acf.third_title,
                        props.state.options.value.acf.third_items,
                        3
                      )}
                      {footerColumn(
                        props.state.options.value.acf.fourth_title,
                        props.state.options.value.acf.fourth_items,
                        4
                      )}
                    </>
                  ) : null}
                </ul>
              </div>
            </div>

            <div className="footer__row footer__row--bottom">
              <div className="footer__inner">
                <div className="block">
                  <Link to="/" className="footer__logo-link">
                    <span className="sr-text">Terug naar bsl.nl</span>
                    <img
                      src="/frontend/images/logo.svg"
                      alt="Logo BSL | Media & Learning"
                      width="80"
                      height="43"
                      loading="eager"
                      className="footer__logo"
                    />
                  </Link>
                  <address className="footer__contact">
                    <div className="footer__contact-item">
                      <svg aria-hidden="true" width="14" height="17">
                        <use xlinkHref="#icon--marker" />
                      </svg>
                      Varrolaan 114, 3584 BW Utrecht
                    </div>
                    <a
                      href="tel:+31306383838"
                      className="footer__contact-item link link--with-icon"
                      onClick={() => DataLayer.clickOnContact('Call')}
                    >
                      <svg aria-hidden="true" width="8" height="14">
                        <use xlinkHref="#icon--phone" />
                      </svg>
                      <span>030 - 638 3838</span>
                    </a>
                    <a
                      href="mailto:info@bsl.nl"
                      className="footer__contact-item link link--with-icon"
                      onClick={() => DataLayer.clickOnContact('Mail')}
                    >
                      <svg aria-hidden="true" width="12" height="9">
                        <use xlinkHref="#icon--mail" />
                      </svg>
                      <span>info@bsl.nl</span>
                    </a>
                  </address>
                  <div className="footer__utility">
                    <a href="#" className="footer__utility-link optanon-toggle-display">
                      Cookie-instellingen
                    </a>
                    <span aria-hidden="true" className="footer__utility-seperator">
                      |
                    </span>
                    <a href="/privacy-statement" className="footer__utility-link">
                      Privacy statement
                    </a>
                    <span aria-hidden="true" className="footer__utility-seperator">
                      |
                    </span>
                    <a href="/disclaimer" className="footer__utility-link">
                      Disclaimer
                    </a>
                    <span aria-hidden="true" className="footer__utility-seperator">
                      |
                    </span>
                    <a href="/voorwaarden" className="footer__utility-link">
                      Voorwaarden
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </BrowserRouter>
      )

      const footerElement = document.getElementById('a11y-footer')
      return footerElement ? ReactDOM.createPortal(jsx, footerElement) : <></>
    }
  })
